import Nullstack from 'nullstack';
export default function IconLadder({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ladder",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 3v18"
  }), "   ", Nullstack.element("path", {
    d: "M16 3v18"
  }), "   ", Nullstack.element("path", {
    d: "M8 14h8"
  }), "   ", Nullstack.element("path", {
    d: "M8 10h8"
  }), "   ", Nullstack.element("path", {
    d: "M8 6h8"
  }), "   ", Nullstack.element("path", {
    d: "M8 18h8"
  }), " ");
}